// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--2_BiW","label":"button-module--label--32VWB","price":"button-module--price--2V0Uv","month":"button-module--month--1JOwm"};